/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module productOptView
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'productOptView';
export const DEFAULTS = {
  triggerElement: 'product__image-alt-trigger',
  altLoadedClass: 'product__image-alt-view--loaded',
  altImage: 'product__image-alt-view'
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - button /element that opens enterable
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
  const opts = $.extend({}, DEFAULTS, $el.data(), options);
  return opts;
};

const getImage = ($el, { altImage }) => {
  const $image = $el.find(`.${altImage}`);
  const imageUrl = $image.data('lazy-src');
  const imageSet = $image.data('lazy-srcset');
  $image
    .removeAttr('data-lazy-src').removeAttr('data-lazy-srcset')
    .attr('src', imageUrl).attr('srcset', imageSet);
}


/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options) => {
  const { triggerElement, altLoadedClass } = options;
  $el.on('mouseenter.showAltImage', `.${triggerElement}`, function(e) {
    if($(this).hasClass(altLoadedClass)) return;
    getImage($(e.currentTarget), options);
    $(this).addClass(altLoadedClass);
  });
};

/**
 * Initializes productOptView.
 * @param {HTMLElement} el - button /element that triggers productOptView
 * @param {Object} options - Options used for wiring up the productOptView
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function productOptView(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, productOptView);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-opt-view.js